import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper';
import { HomeBanner } from '@interface/api';
import { Swiper, SwiperSlide } from 'swiper/react';
import { css } from '@emotion/react';
import { useAPI } from 'src/hooks';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import LoadingContainer from '@com/utils/LoadingContainer';
import SkeletonImage from '@com/utils/SkeletonImage';
import styled from '@emotion/styled';

const Section = styled.div`
  @media (max-width: 991px) {
    padding: 100px 0 0 !important;
  }
`;

const TitleText = styled.p`
  text-shadow: 2px 2px #8a208c;
  @media (max-width: 992px) {
    margin-left: 0 !important;
    margin-right: 40px !important;
  }
`;

function SliderItem(props: { item: HomeBanner }): JSX.Element {
  const { item } = props;

  return (
    <div className="swiper-slide">
      <a href={item.url} rel="noreferrer">
        <div className="slider-item">
          <div className="wrap-cart">
            <div className="cart_item style2 style3">
              <div className="inner-cart">
                <SkeletonImage
                  alt="Banner"
                  loading="eager"
                  size={[320, 640, 768, 1100]}
                  src={item.image}
                />
                <div className="content">
                  <TitleText className="fs-32 mr-4">{item.title}</TitleText>
                  <TitleText className="fs-16 font-weight-light mt-3">
                    {item.description}
                  </TitleText>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
}

function SliderStyle3() {
  /* Define state / hook */
  const { getBannerList } = useAPI();
  const { data, isSuccess, isError } = useQuery(getBannerList.name, () =>
    getBannerList()
  );

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  const Container = useMemo(
    () => styled.div`
      min-height: ${data && data?.length <= 0 ? '0vh' : 'min(32vh, 800px)'};
      display: flex;
      align-items: center;
      width: min(95vw, 1100px);
      margin: auto;
    `,
    [data]
  );

  /* Render */

  return (
    <Section
      className={`home6 style2 mainslider ${
        data && data?.length <= 0 ? 'p-4' : 'flat-cart-item'
      }`}
    >
      <div className="overlay" />
      <Container>
        <LoadingContainer isError={isError} isSuccess={isSuccess}>
          <Swiper
            navigation
            css={css`
              @media (max-width: 991px) {
                padding: 0 !important;
              }
            `}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            spaceBetween={35}
          >
            {data?.map((item: any, index: number) => (
              <SwiperSlide key={index} className="flex justify-content-center">
                <SliderItem item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </LoadingContainer>
      </Container>
    </Section>
  );
}

export default SliderStyle3;
